<template>
  <b-modal
    :title="isNew ? 'Nueva Facturación' : 'Editar Facturación'"
    v-model="showModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    size="lg"
  >
    <b-overlay
      variant="white"
      :show="loadingData || saving"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-form v-on:submit.prevent autocomplete="off" data-vv-scope="newBillingForm">
        <div class="mt-3">
          <h4 class="text-primary">Configuración de ejecución</h4>
          <div class="row mt-2">
            <div class="col col-6">
              <b-form-group label="Esta activo">
                <b-form-checkbox
                  id="emisor.status"
                  v-model="emisor.status"
                  name="emisor.status"
                  :value="true"
                  :unchecked-value="false"
                  data-cy="newBillingForm.emisor.status"
                />
              </b-form-group>
            </div>
            <div class="col col-6">
              <b-form-group label="Emitir como borrador">
                <b-form-checkbox
                  id="emisor.saveAsDraf"
                  v-model="emisor.saveAsDraf"
                  name="emisor.saveAsDraf"
                  :value="true"
                  :unchecked-value="false"
                  data-cy="newBillingForm.emisor.saveAsDraft"
                />
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="row mt-2">
            <div class="col col-6">
              <b-form-group label="Tipo de factura (*)">
                <v-select
                  class="w-100"
                  autocomplete
                  name="newBillingForm.emisor.type"
                  v-model="emisor.type"
                  v-validate="'required'"
                  :danger="errors.has('newBillingForm.emisor.type')"
                  :danger-text="errors.first('newBillingForm.emisor.type')"
                  data-vv-as="Tipo de factura"
                  :options="typeOptions"
                  :reduce="option => option.value"
                  data-cy="newBillingForm.emisor.type"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.emisor.type') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col col-6">
              <b-form-group label="Emitir el día (*)">
                <v-select
                  class="w-100"
                  autocomplete
                  name="newBillingForm.emisor.dayType"
                  v-model="emisor.dayType"
                  v-validate="'required'"
                  :danger="errors.has('nnewBillingForm.emisor.dayType')"
                  :danger-text="errors.first('newBillingForm.emisor.dayType')"
                  data-vv-as="Emitir el día"
                  :options="daysOptions"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.emisor.dayType') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div
              class="col col-6"
              v-if="emisor.dayType === 'otro'"
            >
              <b-form-group label="Dia de emisión (*)">
                <b-form-input
                  id="newBillingForm.emisor.day"
                  name="newBillingForm.emisor.day"
                  data-cy="newBillingForm.emisor.day"
                  placeholder="1"
                  data-vv-as="Dia de emisión"
                  v-model="emisor.day"
                  :state="errors.has('newBillingForm.emisor.day') ?
                  false : null"
                  :danger="errors.has('newBillingForm.emisor.day')"
                  :danger-text="errors.first('newBillingForm.emisor.day')"
                  type="number"
                  :min="1"
                  :max="28"
                  v-validate="'required|min_value:1|max_value:28'"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.emisor.day') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col col-6">
              <b-form-group label="Hora de emisión">
                <v-select
                  class="w-100"
                  autocomplete
                  name="newBillingForm.emisor.hour"
                  v-model="emisor.hour"
                  v-validate="'required'"
                  :danger="errors.has('nnewBillingForm.emisor.hour')"
                  :danger-text="errors.first('newBillingForm.emisor.hour')"
                  data-vv-as="Hora"
                  :options="hoursOptions"
                  :reduce="option => option.value"
                  data-cy="newBillingForm.emisor.hour"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.emisor.hour') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col col-6">
              <b-form-group label="Es factura en cuotas">
                <b-form-checkbox
                  id="emisor.esEnCuota"
                  v-model="emisor.esEnCuota"
                  name="emisor.esEnCuota"
                  :value="true"
                  :unchecked-value="false"
                  data-cy="newBillingForm.emisor.esEnCuota"
                />
              </b-form-group>
            </div>
            <div
              class="col col-6"
              v-if="!emisor.esEnCuota"
            >
              <b-form-group label="Fecha de vigencia">
                <b-form-input
                  id="newBillingForm.emisor.validityDate"
                  name="newBillingForm.emisor.validityDate"
                  data-cy="newBillingForm.emisor.validityDate"
                  placeholder="1"
                  data-vv-as="Fecha de vigencia"
                  v-model="emisor.validityDate"
                  :state="errors.has('newBillingForm.emisor.validityDate') ?
                  false : null"
                  :danger="errors.has('newBillingForm.emisor.validityDate')"
                  :danger-text="errors.first('newBillingForm.emisor.validityDate')"
                  type="date"
                  :min="minDate"
                  v-validate="'today'"
                />
                <small
                  class="text-muted"
                  v-b-tooltip="'Posterior a esta fecha, ya no se ejecutará esta configuración'"
                >
                  Vigencia de la configuración
                </small>
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.emisor.validityDate') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div
              class="col col-6"
              v-if="emisor.esEnCuota"
            >
              <b-form-group label="Número de cuotas">
                <b-form-input
                  id="newBillingForm.emisor.numCuotas"
                  name="newBillingForm.emisor.numCuotas"
                  data-cy="newBillingForm.emisor.numCuotas"
                  placeholder="12"
                  data-vv-as="Número de cuotas"
                  v-model="emisor.numCuotas"
                  v-validate="'required|min_value:1'"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.emisor.numCuotas') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div
              class="col col-6"
              v-if="emisor.esEnCuota"
            >
              <b-form-group label="Número de cuota inicial">
                <b-form-input
                  id="newBillingForm.emisor.numCuota"
                  name="newBillingForm.emisor.numCuota"
                  data-cy="newBillingForm.emisor.numCuota"
                  placeholder="1"
                  data-vv-as="Número de cuota inicial"
                  v-model="emisor.numCuota"
                  v-validate="'required|min_value:1'"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.emisor.numCuota') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <h4 class="text-primary">Información del emisor</h4>
          <div class="row mt-3">
            <div class="col col-6">
              <small>Rut:</small> <br/> {{ company.iut }}
            </div>
            <div class="col col-6">
              <small>Razón Social:</small> <br/> {{ company.razonSocial }}
            </div>
          </div>
          <div class="row mt-2">
            <div class="col col-6">
              <b-form-group label="Sucursal (*)">
                <v-select
                  class="w-100"
                  autocomplete
                  label="direccion"
                  name="newBillingForm.emisor.sucursal"
                  v-model="emisor.sucursal"
                  v-validate="'required'"
                  :danger="errors.has('newBillingForm.emisor.sucursal')"
                  :danger-text="errors.first('newBillingForm.emisor.sucursal')"
                  data-vv-as="Sucursal"
                  :options="branches"
                  :reduce="option => option.sucursalId"
                  data-cy="newBillingForm.emisor.sucursal"
                >
                  <template v-slot:option="option">
                    <feather-icon
                      :icon="option.casaMatriz === 'Y' ? 'HomeIcon' : 'GlobeIcon'"
                      :v-b-tooltip="option.casaMatriz === 'Y' ? 'Casa Matriz' : 'Sucursal'"
                      :color="option.casaMatriz === 'Y' ? 'green' : 'red'"
                    />
                    {{ option.direccion }} {{ option.comuna }} {{ option.ciudad }}
                  </template>
                </v-select>
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.emisor.sucursal') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <h4 class="text-primary">Información del Receptor</h4>
          <div class="row">
            <div class="col col-6">
              <b-form-group
                label="Rut"
                label-for="newBillingForm.receptor.iut"
                class="mb-3"
              >
                <b-form-input-rut
                  id="newBillingForm.receptor.iut"
                  label="Rut (*)"
                  maxlength="10"
                  v-model="receptor.iut"
                  class="w-full"
                  name="newBillingForm.receptor.iut"
                  data-cy="newBillingForm.receptor.iut"
                  data-vv-as="Rut"
                  :state="errors.has('newBillingForm.receptor.iut') ?
                  false : null"
                  :danger="errors.has('newBillingForm.receptor.iut')"
                  :danger-text="errors.first('newBillingForm.receptor.iut')"
                  v-validate="'required|validateRut'"
                  placeholder="12345678-1"
                  @change="onChangeReceiver"
                  @blur="onChangeReceiver"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.receptor.iut') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col col-6">
              <b-form-group
                data-vv-as="Nombre / Razón social"
                label="Nombre / Razón social"
                label-for="newBillingForm.receptor.razonSocial"
                class="mb-3"
              >
                <b-form-input
                  id="newBillingForm.receptor.razonSocial"
                  name="newBillingForm.receptor.razonSocial"
                  placeholder="Nombre"
                  data-vv-as="Nombre"
                  label="Razón social (*)"
                  v-model="receptor.razonSocial"
                  data-cy="newBillingForm.receptor.razonSocial"
                  :state="errors.has('newBillingForm.receptor.razonSocial') ?
                  false : null"
                  :danger="errors.has('newBillingForm.receptor.razonSocial')"
                  :danger-text="errors.first('newBillingForm.receptor.razonSocial')"
                  v-validate="'required'"
                  :disabled="receiverLoading"
                />
                <b-spinner
                  key="primary"
                  class="mr-1"
                  variant="primary"
                  v-if="receiverLoading"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.receptor.razonSocial') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col col-6">
              <b-form-group label="Sucursal (*)">
                <v-select
                  class="w-100"
                  autocomplete
                  label="direccion"
                  id="newBillingForm.receptor.sucursal"
                  name="newBillingForm.receptor.sucursal"
                  data-cy="newBillingForm.receptor.sucursal"
                  v-model="receptor.sucursal"
                  :danger="errors.has('newBillingForm.receptor.sucursal')"
                  :danger-text="errors.first('newBillingForm.receptor.sucursal')"
                  data-vv-as="Sucursal"
                  :options="branchesReceiver"
                  :reduce="option => option.sucursalId"
                  v-validate="'required'"
                >
                  <template v-slot:option="option">
                    <feather-icon
                      :icon="option.casaMatriz === 'Y' ? 'HomeIcon' : 'GlobeIcon'"
                      :v-b-tooltip="option.casaMatriz === 'Y' ? 'Casa Matriz' : 'Sucursal'"
                      :color="option.casaMatriz === 'Y' ? 'green' : 'red'"
                    />
                    {{ option.direccion }} {{ option.comuna }} {{ option.ciudad }}
                  </template>
                </v-select>
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.receptor.sucursal') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <h4 class="text-primary">Datos de la facturación</h4>
          <div class="row">
            <div class="col col-6">
              <b-form-group label="Moneda de emisión (*)">
                <v-select
                  class="w-100"
                  autocomplete
                  name="newBillingForm.detalle.moneda"
                  data-cy="newBillingForm.detalle.moneda"
                  v-model="detalle.moneda"
                  v-validate="'required'"
                  :danger="errors.has('newBillingForm.detalle.moneda')"
                  :danger-text="errors.first('newBillingForm.detalle.moneda')"
                  data-vv-as="Emitir el día"
                  :options="currenciesOptions"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.detalle.moneda') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col col-6">
              <b-form-group
                data-vv-as="Monto"
                label="Monto"
                label-for="newBillingForm.monto"
                class="mb-3"
              >
                <b-form-input
                  id="newBillingForm.detalle.monto"
                  name="newBillingForm.detalle.monto"
                  type="number"
                  data-cy="newBillingForm.detalle.monto"
                  placeholder="1234.5"
                  data-vv-as="Monto"
                  label="Monto (*)"
                  v-model="detalle.monto"
                  :state="errors.has('newBillingForm.detalle.monto') ?
                  false : null"
                  :danger="errors.has('newBillingForm.detalle.monto')"
                  :danger-text="errors.first('newBillingForm.detalle.monto')"
                  v-validate="'required|min_value:1'"
                />
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.detalle.monto') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col col-3">
              <b-form-group label="El monto es bruto">
                <b-form-checkbox
                  id="newBillingForm.detalle.bruto"
                  v-model="detalle.bruto"
                  name="newBillingForm.detalle.bruto"
                  data-cy="newBillingForm.detalle.bruto"
                  :value="true"
                  :unchecked-value="false"
                />
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col  col-12">
              <b-form-group
                data-vv-as="Descripción"
                label="Descripción de la factura"
                label-for="newBillingForm.monto"
                class="mb-3"
              >
                <Taggeable
                  :keys="['{{']"
                  :items="tagsItems"
                >
                  <b-form-textarea-tags
                    id="newBillingForm.detalle.descripcion"
                    name="newBillingForm.detalle.descripcion"
                    type="text"
                    data-cy="newBillingForm.detalle.descripcion"
                    :placeholder="'Factura del mes {{mes_anterior}} '"
                    data-vv-as="Descripción"
                    label="Descripción (*)"
                    v-model="detalle.descripcion"
                    :state="errors.has('newBillingForm.detalle.descripcion') ?
                    false : null"
                    :danger="errors.has('newBillingForm.detalle.descripcion')"
                    :danger-text="errors.first('newBillingForm.detalle.descripcion')"
                    v-validate="'required|max:80'"
                    :tags="tagsItems"
                  />
                </Taggeable>
                <small
                  class="textarea-counter-value float-right"
                  :class="detalle.descripcion.length >= 80 ? 'bg-danger' : ''"
                  v-if="detalle.descripcion.length >= 60"
                >
                  <span class="char-count">{{ detalle.descripcion.length }}</span> / 80
                </small>
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.detalle.descripcion') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col  col-12">
              <b-form-group
                data-vv-as="Detalle"
                label="Detalle de la factura"
                label-for="newBillingForm.monto"
                class="mb-3"
              >
                <Taggeable
                  :keys="['{{']"
                  :items="tagsItems"
                >
                  <b-form-textarea-tags
                    id="newBillingForm.detalle"
                    name="newBillingForm.detalle"
                    type="text"
                    data-cy="newBillingForm.detalle"
                    :placeholder="'Factura del mes {{mes_anterior}} '"
                    data-vv-as="Detalle"
                    label="Descripción (*)"
                    v-model="detalle.detalle"
                    :state="errors.has('newBillingForm.detalle') ?
                    false : null"
                    :danger="errors.has('newBillingForm.detalle')"
                    :danger-text="errors.first('newBillingForm.detalle')"
                    v-validate="'max:1000'"
                    :tags="tagsItems"
                  />
                </Taggeable>
                <small
                  class="textarea-counter-value float-right"
                  :class="detalle.detalle.length >= 1000 ? 'bg-danger' : ''"
                  v-if="detalle.detalle.length >= 800"
                >
                  <span class="char-count">{{ detalle.detalle.length }}</span> / 1000
                </small>
                <b-form-invalid-feedback>
                  {{ errors.first('newBillingForm.detalle') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col col-12">
              <h4 class="text-primary">Referencias</h4>
              <div class="text-right">
                <feather-icon
                  size="25"
                  @click="openModalReferences()"
                  icon="PlusCircleIcon"
                  color="green"
                  class="cursor-pointer"
                  v-b-tooltip="'Agregar Referencia'"
                  data-cy="modal-reference"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="row" v-for="(savedReference, index) in references" :key="index">
                <div class="col col-1">
                  <feather-icon
                    size="25"
                    @click="deleteReference(index)"
                    data-cy="delete-custom"
                    icon="TrashIcon"
                    color="red"
                    class="mt-10 cursor-pointer"
                    v-b-tooltip="'Eliminar Referencia'"
                  />
                </div>
                <div class="col-3">
                  <b-form-group label="Fecha (*)">
                    <b-form-input
                      data-cy="referenceDate"
                      v-model="savedReference.fecha"
                      class="w-full"
                      readonly
                      type="date"
                    />
                  </b-form-group>
                </div>
                <div class="col-5">
                  <b-form-group label="Tipo documento (*)" class="mb-3">
                    <v-select
                      data-cy="referenceType"
                      v-model="savedReference.tipoDocumento"
                      autocomplete
                      class="w-full"
                      readonly
                      :options="documentTypes"
                    />
                  </b-form-group>
                </div>
                <div
                  class="col-3"
                  v-if="savedReference.tipoDocumento && reference.tipoDocumento === '0'"
                >
                  <b-form-group label="Documento (*)" class="mb-3">
                    <b-form-input
                      data-cy="referenceOtherDocument"
                      v-model="savedReference.documento"
                      class="w-full"
                      maxlength="3"
                      readonly
                    />
                  </b-form-group>
                </div>
                <div class="col-2">
                  <b-form-group label="Global" class="mb-3">
                    <b-form-checkbox
                      :value="true"
                      :unchecked-value="false"
                      v-model="savedReference.global"
                    />
                  </b-form-group>
                </div>
                <div class="col-3">
                  <b-form-group label="Folio" class="mb-3" v-if="!savedReference.global">
                    <b-form-input
                      v-model="savedReference.folio"
                      class="w-full"
                      readonly
                    />
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group label="Motivo (*)" class="mb-8">
                    <b-form-input
                      v-model="savedReference.motivo"
                      class="w-full"
                      readonly
                    />
                  </b-form-group>
                </div>
                <div class="col col-1">

                </div>
              </div>
            </div>
            <b-modal
              ref="modal-references"
              size="xl"
              no-close-on-backdrop
              title="Agregar referencia"
              hide-footer
            >
              <div class="col-12">
                <form
                  novalidate
                  data-vv-scope="form-3"
                >
                  <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                      <b-form-group label="Fecha (*)">
                        <b-form-input
                          data-cy="referenceDate"
                          v-model="reference.date"
                          class="w-full"
                          name="referenceDate"
                          :data-vv-as="'fecha'"
                          :state="errors.has('form-3.referenceDate') ?
                      false : null"
                          :danger="errors.has('form-3.referenceDate')"
                          :danger-text="errors.first('form-3.referenceDate')"
                          v-validate="'required'"
                          type="date"
                        />
                        <b-form-invalid-feedback>
                          {{
                            errors.first('form-3.referenceDate')
                          }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-5">
                      <b-form-group label="Tipo documento (*)" class="mb-3">
                        <v-select
                          data-cy="referenceType"
                          v-model="reference.type"
                          autocomplete
                          class="w-full"
                          name="referenceType"
                          :data-vv-as="'tipo documento'"
                          :state="errors.has('form-3.referenceType') ?
                      false : null"
                          :danger="errors.has('form-3.referenceType')"
                          :danger-text="errors.first('form-3.referenceType')"
                          v-validate="'required'"
                          :options="documentTypes"
                        />
                        <b-form-invalid-feedback>
                          {{ errors.first('form-3.referenceType') }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-3" v-if="reference.type && reference.type.value === '0'">
                      <b-form-group label="Documento (*)" class="mb-3">
                        <b-form-input
                          data-cy="referenceOtherDocument"
                          v-model="reference.otherDocument"
                          class="w-full"
                          name="referenceOtherDocument"
                          :data-vv-as="'tipo documento'"
                          maxlength="3"
                          v-validate="{ required: reference.type.value === '0', max: 3 }"
                          :state="errors.has('form-3.referenceOtherDocument') ?
                      false : null"
                          :danger="errors.has('form-3.referenceOtherDocument')"
                          :danger-text="errors.first('form-3.referenceOtherDocument')"
                        />
                        <b-form-invalid-feedback>
                          {{ errors.first('form-3.referenceOtherDocument') }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-2">
                      <b-form-group label="Global" class="mb-3">
                        <b-form-checkbox
                          name="referenceGlobal"
                          :value="true"
                          :unchecked-value="false"
                          data-cy="referenceGlobal"
                          v-model="reference.global"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-3">
                      <b-form-group label="Folio" class="mb-3" v-if="!reference.global">
                        <b-form-input
                          data-cy="referenceNumber"
                          v-model="reference.number"
                          class="w-full"
                          name="referenceNumber"
                          :data-vv-as="'folio'"
                          :state="errors.has('form-3.referenceNumber') ?
                      false : null"
                          :danger="errors.has('form-3.referenceNumber')"
                          :danger-text="errors.first('form-3.referenceNumber')"
                        />
                        <b-form-invalid-feedback>
                          {{ errors.first('form-3.referenceNumber') }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-6">
                      <b-form-group label="Motivo (*)" class="mb-8">
                        <b-form-input
                          data-cy="referenceReason"
                          v-model="reference.reason"
                          class="w-full"
                          name="referenceReason"
                          :data-vv-as="'motivo'"
                          :state="errors.has('form-3.referenceReason') ?
                      false : null"
                          :danger="errors.has('form-3.referenceReason')"
                          :danger-text="errors.first('form-3.referenceReason')"
                          v-validate="'required'"
                        />
                        <b-form-invalid-feedback>
                          {{ errors.first('form-3.referenceReason') }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-1">
                      <feather-icon
                        size="25"
                        @click="addReference()"
                        icon="PlusCircleIcon"
                        v-b-modal="'modal-references'"
                        color="green"
                        class="mt-10 cursor-pointer"
                        v-b-tooltip="'Agregar Referencia'"
                        data-cy="add-reference"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </b-modal>

          </div>
          <div class="row">
            <div class="col  col-12">
              <h4 class="text-primary">Personalizados</h4>
            </div>
            <div class="col  col-12">
              <div
                class="row"
                v-for="personalizado in personalizados"
                :key="personalizado.nombre"
              >
                <div class="col col-1">
                  <feather-icon
                    size="25"
                    @click="deleteCustom(personalizado)"
                    data-cy="delete-custom"
                    icon="TrashIcon"
                    color="red"
                    class="mt-10 cursor-pointer"
                    v-if="personalizado.eliminar"
                    v-b-tooltip="'Eliminar Personalizado'"
                  />
                </div>
                <div class="col  col-3">
                  <vs-select
                    class="w-100"
                    autocomplete
                    label="Tipo"
                    :name="`newBillingForm.personalizado.${personalizado.nombre}.tipo`"
                    v-model="personalizado.tipo"
                    :danger="errors
                    .has(`newBillingForm.personalizado.${personalizado.nombre}.tipo`)"
                    :danger-text="errors
                    .first(`newBillingForm.personalizado.${personalizado.nombre}.tipo`)"
                    data-vv-as="Tipo"
                    :disabled="true"
                  >
                    <vs-select-item
                      :value="customType.CUSTOM_TYPE_TEXT"
                      text="Texto"
                    />
                    <vs-select-item
                      :value="customType.CUSTOM_TYPE_DATE"
                      text="Fecha"
                    />
                    <vs-select-item
                      :value="customType.CUSTOM_TYPE_NUMBER"
                      text="Número"
                    />
                    <vs-select-item
                      :value="customType.CUSTOM_TYPE_OPTIONS"
                      disabled
                      text="Opciones"
                    />
                    <vs-select-item
                      :value="customType.CUSTOM_TYPE_CURRENCY"
                      disabled
                      text="Moneda"
                    />
                    <vs-select-item
                      :value="customType.CUSTOM_TYPE_RATE_EXCHANGE"
                      disabled
                      text="Tasa Cambio"
                    />
                  </vs-select>
                </div>
                <div class="col  col-3">
                  <b-form-group
                    label="Nombre"
                    :label-for="`newBillingForm.personalizado.${personalizado.nombre}.nombre`"
                    class="mb-3"
                  >
                    <b-form-input
                      :id="`newBillingForm.personalizado.${personalizado.nombre}.nombre`"
                      :name="`newBillingForm.personalizado.${personalizado.nombre}.nombre`"
                      :data-cy="`newBillingForm.personalizado.${personalizado.nombre}.nombre`"
                      v-model="personalizado.nombre"
                      class="w-full"
                      :data-vv-as="personalizado.nombre"
                      :state="errors
                      .has(`newBillingForm.personalizado.${personalizado.nombre}.nombre`) ?
                      false : null"
                      :danger="errors
                      .has(`newBillingForm.personalizado.${personalizado.nombre}.nombre`)"
                      :danger-text="errors
                      .first(`newBillingForm.personalizado.${personalizado.nombre}.nombre`)"
                      v-validate=""
                      disabled
                    />
                    <b-form-invalid-feedback>
                      {{
                        errors.first(`newBillingForm.personalizado.${personalizado.nombre}.nombre`)
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col  col-4">
                  <b-form-group
                    v-if="+personalizado.tipo === customType.CUSTOM_TYPE_DATE"
                    :label-for="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                    class="mb-3"
                    label="Valor"
                  >
                    <b-form-input
                      :id="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      :name="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      :data-cy="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      v-model="personalizado.valor"
                      class="w-full"
                      type="date"
                      :data-vv-as="personalizado.nombre"
                      :state="errors
                      .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`) ?
                      false : null"
                      :danger="errors
                      .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      :danger-text="errors
                      .first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      v-validate="'required'"
                    />
                    <b-form-invalid-feedback>
                      {{
                        errors.first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                    v-else-if="+personalizado.tipo === customType.CUSTOM_TYPE_NUMBER"
                    :label-for="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                    class="mb-3"
                    label="Valor"
                  >
                    <b-form-input
                      :id="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      :name="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      :data-cy="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      v-model="personalizado.valor"
                      class="w-full"
                      type="number"
                      :data-vv-as="personalizado.nombre"
                      :state="errors
                      .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`) ?
                      false : null"
                      :danger="errors
                      .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      :danger-text="errors
                      .first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      v-validate="'required'"
                    />
                    <b-form-invalid-feedback>
                      {{
                        errors.first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                    label="Valor (*)"
                    v-else-if="+personalizado.tipo === customType.CUSTOM_TYPE_OPTIONS"
                  >
                    <v-select
                      autocomplete
                      :name="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      v-model="personalizado.valor"
                      v-validate="'required'"
                      :state="errors
                    .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`)
                    ?
                    false : null"
                      :danger="errors
                    .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      :danger-text="errors
                    .first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      :options="personalizado.opciones"
                      :reduce="option => option.valor"
                      label="descripcion"
                      :data-vv-as="personalizado.nombre"
                    />
                    <b-form-invalid-feedback>
                      {{
                        errors.first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                    label="Valor (*)"
                    v-else-if="+personalizado.tipo === customType.CUSTOM_TYPE_CURRENCY"
                  >
                    <v-select
                      autocomplete
                      :name="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      v-model="personalizado.valor"
                      v-validate="'required'"
                      :state="errors
                    .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`)
                    ?
                    false : null"
                      :danger="errors
                    .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      :danger-text="errors
                    .first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      :options="currencies"
                      :reduce="option => option.valor"
                      label="descripcion"
                      :data-vv-as="personalizado.nombre"
                    />
                    <b-form-invalid-feedback>
                      {{
                        errors.first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group
                    label="Valor (*)"
                    v-else-if="+personalizado.tipo === customType.CUSTOM_TYPE_RATE_EXCHANGE"
                  >
                    <v-select
                      autocomplete
                      :name="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      v-model="personalizado.valor"
                      v-validate="'required'"
                      :state="errors
                    .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`)
                    ?
                    false : null"
                      :danger="errors
                    .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      :danger-text="errors
                    .first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      :options="rateOfExchange"
                      :reduce="option => option.value"
                      label="label"
                      :data-vv-as="personalizado.nombre"
                    >
                    </v-select>
                    <b-form-invalid-feedback>
                      {{
                        errors.first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                    v-else
                    :label-for="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                    class="mb-3"
                    label="Valor"
                  >
                    <b-form-input
                      :id="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      :name="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      :data-cy="`newBillingForm.personalizado.${personalizado.nombre}.valor`"
                      v-model="personalizado.valor"
                      class="w-full"
                      type="text"
                      :data-vv-as="personalizado.descripcion"
                      :state="errors
                      .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`) ?
                      false : null"
                      :danger="errors
                      .has(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      :danger-text="errors
                      .first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)"
                      v-validate="'required'"
                    />
                    <b-form-invalid-feedback>
                      {{
                        errors.first(`newBillingForm.personalizado.${personalizado.nombre}.valor`)
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
              </div>
              <form
                novalidate
                @submit.prevent="addCustom('form-2')"
                data-vv-scope="form-2"
              >
                <div class="row">
                  <div class="col col-1">
                  </div>
                  <div class="col  col-3">
                    <b-form-group label="Tipo (*)">
                      <v-select
                        autocomplete
                        :name="`newBillingForm.personalizado.new.tipo`"
                        v-model="personalizado.tipo"
                        :options="customType.AVALAIBLE_CUSTOM_TYPES"
                        :data-vv-as="'Tipo'"
                        :reduce="option => option.valor"
                      />
                    </b-form-group>
                  </div>
                  <div class="col  col-3">
                    <b-form-group label="Nombre" class="mb-3">
                      <b-form-input
                        :id="`newBillingForm.personalizado.new.nombre`"
                        :name="`newBillingForm.personalizado.new.nombre`"
                        :data-cy="`newBillingForm.personalizado.new.nombre`"
                        v-model="personalizado.nombre"
                        class="w-full"
                        :data-vv-as="'Nombre'"
                      />
                    </b-form-group>
                  </div>
                  <div class="col col-1">
                    <feather-icon
                      size="25"
                      @click="addCustom()"
                      icon="PlusCircleIcon"
                      color="green"
                      class="mt-10 cursor-pointer"
                      v-b-tooltip="'Agregar Personalizado'"
                      data-cy="add-custom"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div
          class="mt-5"
          style="display: flex;justify-content: flex-end;"
        >
          <vs-button
            color="dark"
            v-on:click="cancelNewBilling()"
            type="border"
            data-cy="cancel-button"
          >Cancelar
          </vs-button>
          <vs-button
            v-on:click="newBilling()"
            color="primary"
            style="margin-left: 12px;"
            type="border"
            data-cy="save-button"
            :disable="saving"
          >
            Guardar
          </vs-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import RutMixin from '@/febos/chile/_vue/mixins/RutMixin';
import BFormInputRut from '@/components/inputs/BFormInputRut';
import Taggeable from '@/febos/global/billing/components/Taggeable';
import { ioGetCompanyInformation } from '@/febos/servicios/api/empresas.api';
import * as customType from '@/constants/customs_types';
import BFormTextareaTags from '@/febos/global/_vue/componentes/BFormTextareaTags';
import tags from '@/febos/global/billing/settings/PreDefinedTagsTemplates';
import currencies from '@/febos/global/billing/settings/AvailableCurrencies';
import daysOptions from '@/febos/global/billing/settings/AvailableDaysConfigure';
import typeOptions from '@/febos/global/billing/settings/AvailableType';
import hoursOptions from '@/febos/global/billing/settings/AvailableHour';
import documentTypes from '@/febos/global/billing/settings/DocumentTypes';

const initialDetail = {
  bruto: false,
  monto: '0',
  moneda: 'CLP',
  descripcion: '',
  detalle: ''
};

const initialEmisor = {
  status: false,
  type: '33',
  hour: '1',
  saveAsDraf: false,
  dayType: 'P',
  validityDate: null
};

export default {
  name: 'PopUpAsignFile',
  mixins: [RutMixin],
  components: {
    BFormInputRut,
    Taggeable,
    BFormTextareaTags
  },
  data() {
    return {
      tagsItems: tags,
      branches: [],
      branchesReceiver: [],
      minDate: this.$moment()
        .format('YYYY-MM-DD'),
      receiverLoading: false,
      hoursOptions,
      daysOptions,
      typeOptions,
      documentTypes,
      currenciesOptions: currencies,
      customType,
      personalizadosQueNoCambiaTipo: [
        customType.CUSTOM_TYPE_RATE_EXCHANGE,
        customType.CUSTOM_TYPE_OPTIONS,
        customType.CUSTOM_TYPE_CURRENCY
      ],
      personalizado: {},
      reference: {
        global: false
      },
      isFinding: false,
      emisor: initialEmisor,
      receptor: {
        iut: null,
        razonSocial: null,
        giro: null
      },
      receiverBranches: [],
      detalle: initialDetail,
      personalizados: {},
      references: [],
      customs: []
    };
  },
  watch: {
    showModal(isShow) {
      if (isShow) {
        this.onShowModal();
      }
    },
    emisor: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.updateActualData({ emisor: this.emisor });
      }
    },
    receptor: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.updateActualData({ receptor: this.receptor });
      }
    },
    detalle: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.updateActualData({ detalle: this.detalle });
      }
    },
    personalizados: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.updateActualData({ personalizados: this.personalizados });
      }
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Billing', [
      'actualBilling',
      'loadingData',
      'saving',
      'actualId'
    ]),
    ...mapGetters('Empresas', ['company', 'lists']),
    showModal: {
      get() {
        return this.modalName === 'newBilling';
      },
      set() {
        this.closeModal();
      }
    },
    isNew() {
      return this.actualId === 'new';
    },
    currencies() {
      return this.lists[this.company.iut]?.['options-monedas']?.list || [];
    },
    rateOfExchange() {
      return (this.lists[this.company.iut]?.['rate-exchange']?.list || []).map((option) => ({
        label: `${option.tasaCambio} ${option.monedaOrigen} => ${option.monedaDestino}`,
        value: option.tasaCambio
      }));
    }
  },
  methods: {
    ...mapActions('Empresas',
      [
        'fetchCompanyBranches',
        'fetchCompanyOptions',
        'fetchCompanyRateOfExchange'
      ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Billing', [
      'updateActualData',
      'saveBilling'
    ]),
    async onShowModal() {
      this.initData();
      await this.listCompanyOptionsCustoms();
      await this.listCompanyBranches();
      await this.listCompanyOptionsCurrencies();
      await this.listCompanyRateOfExchange();
    },
    initData() {
      this.personalizado = {};
      this.emisor = {
        ...initialEmisor,
        ...this.actualBilling.emisor
      };
      this.receptor = this.actualBilling.receptor;
      this.detalle = {
        ...initialDetail,
        ...this.actualBilling.detalle
      };
      this.personalizados = this.actualBilling.personalizados;
      this.references = this.actualBilling.referencias || [];
      this.loadCustomToField();
      this.searchReceiverBranches();
    },
    async listCompanyOptionsCustoms() {
      if (this.actualId === 'new') {
        const data = await this.fetchCompanyOptions(
          {
            iut: this.company.iut,
            grupoOpcion: 'emision.dte.personalizado'
          }
        );
        this.customs = data;
        this.loadCustomToField();
      }
    },
    async listCompanyOptionsCurrencies() {
      await this.fetchCompanyOptions(
        {
          iut: this.company.iut,
          grupoOpcion: 'monedas'
        }
      );
    },
    async listCompanyRateOfExchange() {
      await this.fetchCompanyRateOfExchange({ iut: this.company.iut });
    },
    loadCustomToField() {
      if (this.actualId === 'new') {
        const personalizados = this.customs.map((opcion) => ({
          ...opcion,
          ...JSON.parse(opcion.extra)
        })).reduce((acumulador, valor) => (
          {
            ...acumulador,
            [valor.nombre]: {
              ...acumulador[valor.nombre],
              nombre: valor.nombre,
              tipo: valor.tipo,
              obligado: valor.obligado,
              eliminar: valor.eliminar,
              descripcion: valor.descripcion,
              valor: acumulador[valor.nombre]?.valor || valor.default,
              opciones: valor.opciones
            }
          }
        ), this.personalizados);
        this.personalizados = personalizados;
      } else {
        const personalizados = this.customs.map((opcion) => ({
          ...opcion,
          ...JSON.parse(opcion.extra)
        })).reduce((acumulador, valor) => {
          if (!acumulador[valor.nombre]) {
            return acumulador;
          }
          return {
            ...acumulador,
            [valor.nombre]: {
              ...acumulador[valor.nombre],
              nombre: valor.nombre,
              tipo: valor.tipo,
              obligado: valor.obligado,
              eliminar: valor.eliminar,
              descripcion: valor.descripcion,
              valor: acumulador[valor.nombre]?.valor || valor.default,
              opciones: valor.opciones
            }
          };
        }, this.personalizados);
        this.personalizados = personalizados;
      }
    },
    async listCompanyBranches() {
      await this.fetchCompanyBranches({
        iut: this.company.iut,
        filter: 'sucursalActiva:Y'
      });
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async searchReceiverInfo() {
      this.receiverLoading = true;
      const { data } = await ioGetCompanyInformation(
        {
          iutEmpresa: this.receptor.iut,
          seOmiteErrorReport: true
        }
      );
      this.receiverLoading = false;
      if (data.codigo === 10) {
        this.receptor = {
          ...this.receptor,
          iut: data.iut,
          razonSocial: data.razonSocial,
          giro: data.giro
        };
      }
    },
    async searchReceiverBranches() {
      if (this.receptor.iut) {
        await this.fetchCompanyBranches({
          iut: this.receptor.iut,
          filter: 'sucursalActiva:Y'
        });
        this.branchesReceiver = this.lists[this.receptor.iut]?.branches?.list || [];
      }
    },
    async onChangeReceiver() {
      this.isFinding = true;
      try {
        if (this.validateRUT(this.receptor.iut)) {
          await this.searchReceiverInfo();
          await this.searchReceiverBranches();
        }
      } finally {
        this.isFinding = false;
      }
    },
    deleteCustom(custom) {
      const {
        [custom.nombre]: ignored,
        ...customs
      } = this.personalizados;
      this.personalizados = customs;
    },
    addCustom() {
      const {
        nombre,
        tipo
      } = this.personalizado;
      if (!nombre || !tipo) {
        return;
      }
      const regex = /^[a-zA-Z0-9._/-]+$/gm;
      const replaceReg = /[^a-zA-Z0-9._/-]/gm;
      let cleaned = nombre;
      if (!cleaned.match(regex)) {
        cleaned = cleaned.replace(replaceReg, '');
      }
      const custom = {
        ...this.personalizado,
        nombre: cleaned,
        eliminar: true
      };
      if (this.personalizados[custom.nombre]) {
        return;
      }
      this.personalizados = {
        ...this.personalizados,
        [custom.nombre]: custom
      };
    },
    openModalReferences() {
      this.$refs['modal-references'].show();
    },
    async addReference() {
      const isValid = await this.validateForm('form-3');
      if (!isValid) {
        return;
      }

      const reference = {
        tipoDocumento: this.reference.type.value,
        documento: this.reference.otherDocument || '',
        global: this.reference.global,
        folio: this.reference.number || '',
        fecha: this.reference.date,
        tipoMotivo: '',
        motivo: this.reference.reason,
        otros: false
      };
      this.references.push(reference);
      this.reference = { global: false };
      this.$refs['modal-references'].hide();
    },
    deleteReference(index) {
      this.references.splice(index, 1);
    },
    cancelNewBilling() {
      this.emisor = {
        iut: null,
        razonSocial: null
      };
      this.receptor = {
        iut: null,
        razonSocial: null
      };
      this.closeModal();
    },
    async newBilling() {
      const isValid = await this.validateForm('newBillingForm');
      if (!isValid) {
        return;
      }
      await this.saveBilling(this.references);
      this.$bvToast.toast(
        'Configuración guardada correctamente',
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
    }
  },
  async created() {
    this.$validator.extend('today', {
      getMessage: () => 'La fecha debe ser mayor a hoy',
      validate: (value) => {
        if (!value) {
          return true;
        }
        return this.$moment(value)
          .isSameOrAfter(this.$moment(), 'day');
      }
    });
    await this.listCompanyBranches();
    this.branches = this.lists[this.company.iut]?.branches?.list || [];
  }
};
</script>
<style scoped>
.invalid-feedback {
  display: block !important;
}
</style>
